import styled, { css } from 'styled-components';
import { styleMixinInvertedFocusOutline, Tag } from '@amzn/storm-ui';
import { Button } from 'src/features/header/components/PageHeader/Actions/styles';

export const BoldText = styled.span`
  font-weight: bold;
  font-family: 'AmazonEmber-Bold', 'Amazon Ember', Arial, Helvetica, sans-serif;
`;

export const PageTitleTag = styled(Tag)`
  margin: 0 ${({ theme }) => theme.spacing.xsmall.default};
`;

export const overrideMouseLeaveTimeout = (theme) => ({
  ...theme,
  tooltip: {
    ...theme.tooltip,
    mouseLeaveTimeout: 0,
  },
});

export const StylelessButton = styled(Button)<{ isRenderedInHeader: boolean }>`
  &&& {
    color: inherit;
    padding: 0;
    border-radius: 10%;
    font-size: inherit;

    :hover,
    :active,
    :focus,
    :focus-visible {
      background: none;
    }

    ${({ isRenderedInHeader }) =>
      isRenderedInHeader &&
      css`
        :focus-visible {
          ${styleMixinInvertedFocusOutline};
        }
      `};
  }
`;
